import { materialRenderers } from '@jsonforms/material-renderers'
import { elementDisplayRenderer } from 'designer/component/control/renderer/PageElementDisplay'
import { containerDisplayRenderer } from 'designer/component/control/renderer/ContainerDisplay'
import { widgetDisplayRenderer } from 'designer/component/control/renderer/WidgetDisplay'
import { componentDisplayRenderer } from 'designer/component/control/renderer/ComponentDisplay'

import { elementSystemRenderer } from 'designer/component/control/renderer/PageElementSystem'
import { containerSystemRenderer } from 'designer/component/control/renderer/ContainerSystem'
import { widgetSystemRenderer } from 'designer/component/control/renderer/WidgetSystem'
import { componentSystemRenderer } from 'designer/component/control/renderer/ComponentSystem'

import objectPath from 'object-path'
import { favoriteRenderer } from './Favorite'
import {
  getActiveTabElements,
  getElementRendererList,
  getRendererTagname,
} from './RendererHelper'

const createRenderer = (renderList, elements = []) => {
  let renderers = [...materialRenderers]
  let rendererElements = elements.reduce((result, element) => {
    return [...result, ...getElementRendererList(element)]
  }, [])

  rendererElements.forEach((element) => {
    let { uiType, subGroup } = element
    let tagname = getRendererTagname(element)
    let tester = renderList[tagname]
    if (uiType === 'container') {
      let keyType = !subGroup ? 'main' : 'sub'
      if (objectPath.has(renderList, [keyType, tagname])) {
        tester = objectPath.get(renderList, [keyType, tagname])
      } else {
        tester = objectPath.get(renderList, tagname)
      }
    }
    if (tester) {
      renderers.push(tester)
    }
  })
  return renderers
}

export const createSwitchRenderer = (elements = [], isFirstElement) => {
  const renderSystemList = {
    ...elementSystemRenderer,
    ...containerSystemRenderer,
    ...componentSystemRenderer,
    ...widgetSystemRenderer,
  }

  const renderDisplayList = {
    ...elementDisplayRenderer,
    ...containerDisplayRenderer,
    ...componentDisplayRenderer,
    ...widgetDisplayRenderer,
  }
  let renderList = isFirstElement ? renderSystemList : renderDisplayList
  let renderers = createRenderer(renderList, elements)
  return renderers
}

export const createDisplayRenderer = (elements = []) => {
  const renderList = {
    ...elementDisplayRenderer,
    ...containerDisplayRenderer,
    ...componentDisplayRenderer,
    ...widgetDisplayRenderer,
  }
  let renderers = createRenderer(renderList, elements)
  return renderers
}

export const createSystemRenderer = (elements = []) => {
  const renderList = {
    ...elementSystemRenderer,
    ...containerSystemRenderer,
    ...componentSystemRenderer,
    ...widgetSystemRenderer,
  }
  let renderers = createRenderer(renderList, elements)
  return renderers
}

export const createFavoriteRenderer = (elements = []) => {
  const renderList = favoriteRenderer
  let renderers = createRenderer(renderList, elements)
  return renderers
}

export const createTabSystemRenderer = (elements = [], activeTab) => {
  let foundTab = getActiveTabElements(elements, activeTab)
  let renderers = createSystemRenderer(foundTab)
  return renderers
}

export const createTabDisplayRenderer = (elements = [], activeTab) => {
  let foundTab = getActiveTabElements(elements, activeTab)
  let renderers = createDisplayRenderer(foundTab)
  return renderers
}

export const createPanelGroupSystemRenderer = (elements = [], activeTab) => {
  let foundTab = elements.filter(({ key }) => key === activeTab)
  let renderers = createSystemRenderer(foundTab)
  return renderers
}

export const createPanelGroupDisplayRenderer = (elements = [], activeTab) => {
  let foundTab = elements.filter(({ key }) => key === activeTab)
  let renderers = createDisplayRenderer(foundTab)
  return renderers
}
